module.exports = __webpack_public_path__ + "img/客户案例-res-bg@2x.8cac0651.png";